import * as THREE from "three";
// Agents may carry extra accessory joints. Preserve their hierarchy while the
// common arm joints follow the knife animation skeleton.
export function retargetFirstPerson(
  source: THREE.SkinnedMesh,
  target: THREE.Group,
) {
  const resolve = (bone: THREE.Bone): THREE.Bone => {
    const existing = target.getObjectByName(bone.name);
    if (existing instanceof THREE.Bone) return existing;
    const copy = new THREE.Bone();
    copy.name = bone.name;
    copy.position.copy(bone.position);
    copy.quaternion.copy(bone.quaternion);
    copy.scale.copy(bone.scale);
    const parent =
      bone.parent instanceof THREE.Bone ? resolve(bone.parent) : target;
    parent.add(copy);
    return copy;
  };
  const bones = source.skeleton.bones.map(resolve);
  const mesh = new THREE.SkinnedMesh(source.geometry, source.material);
  mesh.name = source.name;
  mesh.frustumCulled = false;
  mesh.position.copy(source.position);
  mesh.quaternion.copy(source.quaternion);
  mesh.scale.copy(source.scale);
  mesh.bind(
    new THREE.Skeleton(bones, source.skeleton.boneInverses),
    source.bindMatrix,
  );
  return mesh;
}
